<template>
    <span class="label label-primary">{{filecount}}</span>
</template>

<script>
    export default {
        props: {
            'count': {
                default: 0
            }
        },
        computed: {
            filecount: function () {
                return this.count + ' ' + Lang.langChoice("File|Files", this.count);
            }
        }
    }
</script>
